(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cg-gift-card-recipient"] && !Shopify.designMode) return;
  try {
    (function () {
  var toggle = document.getElementById('cg-gcr-toggle');
  if (!toggle) return;

  var fields = document.getElementById('cg-gcr-fields');
  var email = document.getElementById('cg-gcr-email');
  var display = document.getElementById('cg-gcr-send-on');         // visible DD/MM/YYYY text field
  var native = document.getElementById('cg-gcr-send-on-native');   // hidden native picker (calendar source)
  var iso = document.getElementById('cg-gcr-send-on-iso');         // hidden, submits YYYY-MM-DD to Shopify
  var dateBtn = document.getElementById('cg-gcr-date-btn');
  var offset = document.getElementById('cg-gcr-offset');
  var message = document.getElementById('cg-gcr-message');
  var counter = document.getElementById('cg-gcr-counter');
  var inputs = fields ? fields.querySelectorAll('input, textarea') : [];

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function todayISO() {
    var d = new Date();
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
  }

  var minISO = todayISO();
  if (native) native.min = minISO;

  // YYYY-MM-DD -> DD/MM/YYYY
  function isoToUK(value) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || '');
    return m ? m[3] + '/' + m[2] + '/' + m[1] : '';
  }

  // DD/MM/YYYY -> YYYY-MM-DD. Returns '' unless it is a real date on or after today.
  function ukToISO(value) {
    var m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec((value || '').trim());
    if (!m) return '';
    var dd = parseInt(m[1], 10), mm = parseInt(m[2], 10), yyyy = parseInt(m[3], 10);
    var d = new Date(yyyy, mm - 1, dd);
    if (d.getFullYear() !== yyyy || d.getMonth() !== mm - 1 || d.getDate() !== dd) return '';
    var out = yyyy + '-' + pad(mm) + '-' + pad(dd);
    return out < minISO ? '' : out;
  }

  // Auto-insert slashes as digits are typed: 28062026 -> 28/06/2026
  function maskUK(value) {
    var digits = value.replace(/\D/g, '').slice(0, 8);
    var out = digits.slice(0, 2);
    if (digits.length >= 3) out += '/' + digits.slice(2, 4);
    if (digits.length >= 5) out += '/' + digits.slice(4, 8);
    return out;
  }

  function setInvalid(on) {
    if (display) display.classList.toggle('cg-gcr__invalid', on);
  }

  // Read the visible field, validate, and mirror into the hidden ISO + native picker.
  function commitFromDisplay() {
    if (!display || !iso) return;
    if (!display.value.trim()) {
      iso.value = '';
      if (native) native.value = '';
      setInvalid(false);
      return;
    }
    var out = ukToISO(display.value);
    iso.value = out;
    if (native) native.value = out;
    setInvalid(!out);
  }

  // Mirror a calendar pick back into the visible field + hidden ISO.
  function commitFromNative() {
    if (!native) return;
    if (display) display.value = isoToUK(native.value);
    if (iso) iso.value = native.value || '';
    setInvalid(false);
  }

  if (display) {
    display.addEventListener('input', function () {
      display.value = maskUK(display.value);
      commitFromDisplay();
    });
    display.addEventListener('blur', commitFromDisplay);
  }

  if (native) {
    native.addEventListener('input', commitFromNative);
    native.addEventListener('change', commitFromNative);
  }

  if (dateBtn && native) {
    dateBtn.addEventListener('click', function () {
      if (native.disabled) return;
      try {
        if (typeof native.showPicker === 'function') { native.showPicker(); return; }
      } catch (e) {}
      native.focus();
      native.click();
    });
  }

  function sync() {
    var on = toggle.checked;
    for (var i = 0; i < inputs.length; i++) {
      inputs[i].disabled = !on;
    }
    if (dateBtn) dateBtn.disabled = !on;
    if (email) email.required = on;
    if (offset) offset.value = on ? String(new Date().getTimezoneOffset()) : '';
  }

  toggle.addEventListener('change', sync);

  if (message && counter) {
    message.addEventListener('input', function () {
      counter.textContent = message.value.length + ' / 200';
    });
  }

  sync();
})();
  } catch(e) { console.error(e); }
})();

})();
